import React, { Suspense, useEffect, useState } from 'react';
import { connect, useDispatch, useStore } from 'react-redux';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { AuthRoute } from './AuthRoute';
import LoggedBottomMenu from './components/common/CommonViews';
import { history } from './history';
import {
  AdminCalendar,
  AdminCompanyAdd,
  AdminCompanyEdit,
  AdminCompanyList,
  AdminCustomFieldList,
  AdminErrorCodeAdd, AdminErrorCodeInfo,
  AdminErrorCodeList,
  AdminErrorInfo,
  AdminErrorList,
  AdminInstallationInfo,
  AdminInstallationList,
  AdminLogin,
  AdminProductAdd,
  AdminProductInfo,
  AdminProductList,
  AdminProductPart,
  AdminProductPartInfo,
  AdminProductStockList,
  AdminRayCode, AdminRayCodeInfo,
  AdminRayDataList,
  AdminServiceAdd,
  AdminServiceInfo,
  AdminServiceList,
  AdminSiteAdd,
  AdminSiteEdit,
  AdminSiteList,
  AdminSiteSurveyInfo,
  AdminSiteSurveyList,
  AdminUserAdd, AdminUserEdit, AdminUserList,
} from './pages/admin';
import lazyWithRetry from './lib/lazyWithRetry';
import { Loading } from './components/common/Loading';
import { ForgotPassword, ForgotPasswordSent, IubendaLogin, LoginPage, ResetNewPassword } from './pages/auth';
import ErrorCodeLookup from './pages/errorcode/ErrorCodeLookup';
import { MyTask } from './pages/mytask';
import ServiceDetail from './pages/service/ServiceDetail';
import { PasswordConfirm, UpdatePassword, UserAccount, UserSettings } from './pages/user';

import { AlertAction, AuthAction, CompanyAction, CustomFieldAction, RayCodeAction, TranslateAction } from './actions';
import WebSocketService from './lib/WebSocketService';
import { resolveUnauthRedirect, isAdminContextPath } from './lib/loginRedirect';
import { isExternalDealerPathAllowed, EXTERNAL_DEALER_LANDING, normalizePathname } from './lib/rbacGuard';
import { getLicenseRole } from './lib/licenseHelper';
import { safeGetItem, safeGetJSON, safeSetItem } from './lib/safeStorage';
import { ROLE_EXTERNAL_DEALER } from './config/appConstants';
import { ROUTES } from './config/routes';
import { SideMenu } from './components/common';
import ErrorBoundary from './components/common/ErrorBoundary';
import NotFound from './components/common/NotFound';
import HomePage from './pages/HomePage';
import { SiteListView } from './pages/site';
//import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './asset/css/common.css';
import AdminLeftMenu from './components/common/AdminLeftMenu';
import AdminTopMenu from './components/common/AdminTopMenu';
import { LoggedAdminFooter, Toast } from './components/common/CommonViews';
import ProductErrorEdit from './components/product/ProductErrorEdit';
import InstallationGuide from './pages/guides/InstallationGuide';
import SettingWizardGuide from './pages/guides/SettingWizardGuide';
import Installation from './pages/mytask/Installation';
import MyCalendar from './pages/mytask/MyCalendar';
import MyFavorite from './pages/mytask/MyFavorite';
import MyGuide from './pages/mytask/MyGuide';
import MyNotification from './pages/mytask/MyNotification';
import MySearch from './pages/mytask/MySearch';
import QRScan from './pages/mytask/QRScan';
import SiteSurvey from './pages/mytask/SiteSurvey';
import ProductRegistByUser from './pages/product/ProductRegistByUser';
import ProductView from './pages/product/ProductView';
import ServiceAddNew from './pages/service/ServiceAddNew';
import SiteView from './pages/site/SiteView';
import MyInfo from './pages/user/MyInfo';
import MyReportManager from './pages/user/MyReportManager';
import { UserInfo } from './pages/user/UserInfo';

// BUG-221: 'moment/locale/*' 를 여기서 직접 import 하지 않는다 — 로케일 파일 로드는
// defineLocale() 이 전역 로케일을 바꾸는 부작용이 있어, 마지막 import 가 앱 기본값이 된다.
// import 는 config/momentLocale 한 곳에만 둔다.
import { syncMomentLocaleFromStorage } from './config/momentLocale';
import { resolveUserLangCode } from './config/currentLang';
import { LicenseAction } from './actions';
import AdminTenYears from './pages/admin/AdminTenYears';
import AdminServiceStatus from './pages/admin/AdminServiceStatus';
import AdminNotificationEmailSetting from './pages/admin/AdminNotificationEmailSetting';
import AdminPMCFRegistry from './pages/admin/AdminPMCFRegistry';
import LicenseHub from './pages/admin/license/LicenseHub';
import ServiceModalPopup from './components/servicemodal/ServiceModalPopup';

// IMP-337 (FE-C2) — 무거운 admin 라우트 lazy 전환 (barrel 제거, 파일별 lazy import)
const AdminDashboard = lazyWithRetry(() => import('./pages/admin/AdminDashboard'), 'AdminDashboard');
const AdminErrorDashboard = lazyWithRetry(() => import('./pages/admin/AdminErrorDashboard'), 'AdminErrorDashboard');
const AdminProductDashboard = lazyWithRetry(() => import('./pages/admin/AdminProductDashboard'), 'AdminProductDashboard');
const AdminServiceDashboard = lazyWithRetry(() => import('./pages/admin/AdminServiceDashboard'), 'AdminServiceDashboard');
const AdminSiteDashboard = lazyWithRetry(() => import('./pages/admin/AdminSiteDashboard'), 'AdminSiteDashboard');
const AdminWarrantyDashboard = lazyWithRetry(() => import('./pages/admin/AdminWarrantyDashboard'), 'AdminWarrantyDashboard');
const AdminStatistics = lazyWithRetry(() => import('./pages/admin/AdminStatistics'), 'AdminStatistics');
const AdminProductImport = lazyWithRetry(() => import('./pages/admin/AdminProductImport'), 'AdminProductImport');
const AdminProductImportSmall = lazyWithRetry(() => import('./pages/admin/AdminProductImportSmall'), 'AdminProductImportSmall');
const AdminProductImportShipment = lazyWithRetry(() => import('./pages/admin/AdminProductImportShipment'), 'AdminProductImportShipment');
const AdminProductCompanyImport = lazyWithRetry(() => import('./pages/admin/AdminProductCompanyImport'), 'AdminProductCompanyImport');
const AdminServiceExportCSR = lazyWithRetry(() => import('./pages/admin/AdminServiceExportCSR'), 'AdminServiceExportCSR');
const AdminTranslate = lazyWithRetry(() => import('./pages/admin/AdminTranslate'), 'AdminTranslate');
const AdminSpareParts = lazyWithRetry(() => import('./pages/admin/AdminSpareParts'), 'AdminSpareParts');
const AdminSparePartsDetail = lazyWithRetry(() => import('./pages/admin/AdminSparePartsDetail'), 'AdminSparePartsDetail');
const AdminSparePartsOrder = lazyWithRetry(() => import('./pages/admin/AdminSparePartsOrder'), 'AdminSparePartsOrder');
const AdminSparePartsOrderFree = lazyWithRetry(() => import('./pages/admin/AdminSparePartsOrderFree'), 'AdminSparePartsOrderFree');
const AdminSparePartsOrderList = lazyWithRetry(() => import('./pages/admin/AdminSparePartsOrderList'), 'AdminSparePartsOrderList');
const AdminSparePartsOrderListManager = lazyWithRetry(() => import('./pages/admin/AdminSparePartsOrderListManager'), 'AdminSparePartsOrderListManager');
const AdminSparePartsOrderDetail = lazyWithRetry(() => import('./pages/admin/AdminSparePartsOrderDetail'), 'AdminSparePartsOrderDetail');
const AdminSparePartsInRegist = lazyWithRetry(() => import('./pages/admin/AdminSparePartsInRegist'), 'AdminSparePartsInRegist');
const AdminSparePartsOutRegist = lazyWithRetry(() => import('./pages/admin/AdminSparePartsOutRegist'), 'AdminSparePartsOutRegist');
const AdminSparePartsDealerOutRegist = lazyWithRetry(() => import('./pages/admin/AdminSparePartsDealerOutRegist'), 'AdminSparePartsDealerOutRegist');
const AdminSparePartsOutList = lazyWithRetry(() => import('./pages/admin/AdminSparePartsOutList'), 'AdminSparePartsOutList');
const AdminSparePartsOutDetail = lazyWithRetry(() => import('./pages/admin/AdminSparePartsOutDetail'), 'AdminSparePartsOutDetail');
const AdminSparePartsCompany = lazyWithRetry(() => import('./pages/admin/AdminSparePartsCompany'), 'AdminSparePartsCompany');
const AdminSparePartsCompanyDetail = lazyWithRetry(() => import('./pages/admin/AdminSparePartsCompanyDetail'), 'AdminSparePartsCompanyDetail');
const AdminSparePartsStock = lazyWithRetry(() => import('./pages/admin/AdminSparePartsStock'), 'AdminSparePartsStock');
const AdminSparePartsCIPublish = lazyWithRetry(() => import('./pages/admin/AdminSparePartsCIPublish'), 'AdminSparePartsCIPublish');

const EmtryCom = () => {
	return <></>
}

// F-001: /Terms 는 public/terms/*.html 정적 파일이다. <Redirect> 는 클라이언트 라우터 내부 이동이라
// 정적 파일이 요청되지 않고 NotFound 로 떨어지므로, 전체 내비게이션(location.replace)으로 연다.
// 기존 두 <Redirect push> 중 마지막이 최종 도착지였던 terms_kr.html 을 유지한다(언어 분기 규칙 없음).
const TermsRedirect = () => {
	useEffect(() => {
		window.location.replace(`${process.env.PUBLIC_URL || ''}/terms/terms_kr.html`);
	}, []);
	return null;
};

// BUG(관리자 레이아웃 잔류): isAdmin/isDashboard 판정 SSoT.
// App 은 <Router history={history}> 바깥이라 useLocation 을 쓸 수 없다 — history.listen 구독으로
// pathname 변경 시 재계산한다(아래 useEffect 참고). 판정식 자체는 기존과 동일, 중복 회피만 목적.
export const computeLayoutFlags = (pathname) => {
	const lower = (pathname || '').toLowerCase();
	return {
		isAdmin: isAdminContextPath(lower),
		isDashboard: lower.includes('/admin/dashboard'),
	};
};

const App = ({ alert, user, companies, userToken, isLogin, translate, AlertClose, GetAllCompany, GetAllCustomField, GetLicenseByCompanyId }) => {
	const [isAdmin, setIsAdmin] = useState(() => computeLayoutFlags(location.pathname).isAdmin);
	const [alertToast, setAlertToast] = useState({ type: "success", show: false, message: "" });
	const [isDashboard, setIsDashboard] = useState(() => computeLayoutFlags(location.pathname).isDashboard);
	const [standAlone, setStandAlone] = useState(false);
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const store = useStore();

	// BUG(관리자 레이아웃 잔류): isAdmin/isDashboard 는 마운트 시점 pathname 으로 한 번만
	// 계산되고 이후 SPA 내비게이션(history.push/replace, 예: AuthRoute 가드의 /Home 회수)에
	// 따라 갱신되지 않았다. 그 결과 관리자 레이아웃이 남은 채 주소만 바뀌어, 그 안의
	// <Switch>에 매칭되는 라우트가 없어 본문이 조용히 빈 채로 렌더됐다(콘솔 예외 없음).
	// history.listen 으로 구독해 경로가 바뀔 때마다 동일 판정식을 다시 적용한다.
	useEffect(() => {
		const apply = (pathname) => {
			const flags = computeLayoutFlags(pathname);
			setIsAdmin((prev) => (prev === flags.isAdmin ? prev : flags.isAdmin));
			setIsDashboard((prev) => (prev === flags.isDashboard ? prev : flags.isDashboard));
		};
		const unlisten = history.listen((loc) => apply(loc.pathname));
		// 마운트 중 <Redirect> 가 구독보다 먼저 주소를 바꾸면 그 이동을 못 받으므로 현재 주소로 한 번 맞춘다.
		const current = history.location?.pathname;
		if (typeof current === 'string') apply(current);
		return () => unlisten();
	}, []);

	const setLocale = () => {
		const user = safeGetJSON('user');
		if (user) {
			const language = resolveUserLangCode(user);
			// BUG-221: 로케일 전환 로직은 config/momentLocale 하나만 둔다. 종전에는 여기와
			// UserSettings.js 에 19-case switch 가 **똑같이 두 벌** 있었고(CLAUDE.md §6),
			// 각자 'moment/locale/*' 를 import 해 전역 로케일이 마지막 import(ru)로 굳었다.
			// 이 시점 적용은 보조 수단이다 — 첫 렌더보다 앞서야 하므로 실제 적용은
			// config/momentLocale 모듈 평가 시점에 이미 끝나 있다(이 useEffect 는 렌더 이후).
			syncMomentLocaleFromStorage();

			TranslateAction.SearchByLanguageDirect(language).then(translate => {
				safeSetItem('translate', JSON.stringify(translate));
			});
		}
	}

	useEffect(() => {
		if (isLogin) {
			dispatch(CompanyAction.GetCompanyByToken(userToken));
			getManagerGroupInfoByCompanyId();
			// WebSocket 실시간 연결 초기화
			WebSocketService.init(dispatch, store.getState.bind(store));
			WebSocketService.connect();
		} else {
			WebSocketService.disconnect();
		}
	}, [isLogin]);

	useEffect(() => {
		setLoading(true);
		setLocale();
		setStandAlone(location.pathname.toLowerCase().startsWith('/register'))
		// BUG-241: safeGetJSON 은 getItem 실패(safeGetItem 내부 흡수) 뿐 아니라 파싱 결과가
		// 비객체(null 포함)인 경우도 null 로 흡수한다 — user='null' 같은 잔존값이 아래
		// 로그인 분기(가드 계층)로 들어가지 않고 else(비로그인) 경로로 수렴하게 한다.
		const parsedUser = safeGetJSON('user');
		const clist = safeGetItem('clist');
		if (parsedUser && clist) {
			// 가드 계층 (PR #192 review Architecture Major) — drift 회피 정책:
			//   1차 (본 useEffect): 최초 mount 시 hard-load 진입 차단. SPA 내비게이션은 트리거 안 됨.
			//   2차 (AuthRoute / AdminAuthRoute): 매 렌더 시 평가 — SSoT. SPA 내비게이션 포함 모든
			//        진입 검사. 본 useEffect 와 동일한 isExternalDealerPathAllowed 헬퍼 공유로 drift 차단.

			// F-002(동의 미완료 세션) 차단은 여기 없다 — FEAT-052 (#493) 에서 AuthRoute/
			// AdminAuthRoute 한 계층으로 합쳤다.
			//
			// 종전에는 이 자리에서 /IubendaLogin 으로 전체 페이지를 이동시켰고, 그 이동이
			// **새 페이지에서 init() 을 다시 돌려줬기 때문에** 여기서 early return 해도 문제가
			// 없었다. 동의를 모달로 받으면 그 이동이 사라진다 — early return 을 남겨두면
			// 동의 직후 열리는 화면이 RayCode·CustomField 없이 뜨고, 리로드 전까지 그대로다.
			// 그래서 앱 셸은 정상 초기화하고, **화면 차단은 라우트 가드에만 맡긴다**
			// (보호 경로는 전부 AuthRoute/AdminAuthRoute 를 거친다 — 아래 Switch 참고).
			// 대가로 동의 전 사용자의 redux 에도 마스터 코드(RayCode)·커스텀 필드 정의가 적재된다
			// — 종전에는 건너뛰었다. 화면에는 노출되지 않고(보호 화면이 렌더되지 않는다) 이용자
			// 데이터가 아닌 공용 정의라 받아들인 트레이드오프다. 회사 정보·WebSocket 은 종전에도
			// 동의 여부와 무관하게 연결됐다(위 isLogin useEffect).

			const roleForGuard = getLicenseRole(parsedUser);

			// BUG-101: ExternalDealer 는 tech 포털(/Home 등) 진입 불가 — EXTERNAL_DEALER_LANDING 으로 회수.
			// isAdmin 은 초기 pathname 기반 state 라 SPA redirect 로 변경 불가.
			// window.location.assign(hard reload) 만이 admin 포털로 올바르게 전환함.
			// normalizePathname: URL 인코딩·대소문자 우회 방지 (PR #192 Security 강화와 동일 스펙).
			if (roleForGuard === ROLE_EXTERNAL_DEALER && !normalizePathname(location.pathname).startsWith('/admin/')) {
				window.location.assign(EXTERNAL_DEALER_LANDING);
				return;
			}

			// permAdminAccess 없는 사용자가 /admin/* 진입 시 회수.
			// ExternalDealer 는 화이트리스트 경로만 허용 (FEAT-025 SPEC-RG-04).
			// ExternalDealer 는 위 early return 이후 도달 불가 — 비-ExternalDealer 만 /Home 으로 회수.
			if (!parsedUser.permAdminAccess && normalizePathname(location.pathname).startsWith('/admin/')) {
				const allowed = roleForGuard === ROLE_EXTERNAL_DEALER && isExternalDealerPathAllowed(location.pathname);
				if (!allowed) {
					window.location.assign(ROUTES.HOME);
				}
			}
			if (location.pathname.toLowerCase().startsWith('/admin/')) {
				//GetAllCompany();
				GetAllCustomField();
			}
			init();
		}else{
			setLoading(false);
			// F-005: AuthAction.Logout() 이 내부에서 history.replace 로 로그인 경로로 이동시켜
			// window.location 을 즉시 바꿔버린다. Logout() 호출 전에 원경로를 캡처해둬야
			// 아래 판정과 state.from 이 원래 딥링크 경로를 기준으로 동작한다.
			const preLogoutPathname = location.pathname;
			const preLogoutSearch = location.search;
			dispatch(AuthAction.Logout());
			// BUG-134: 미로그인 hard-load — 무조건 /Login push 가 AuthRoute deep-link(state.from)를
			// 덮어써 원경로(/pmcf 등) 복귀가 끊김. admin 컨텍스트 분기 + 원경로를 state.from 으로 보존.
			// 이미 로그인 경로면 push 생략(루프 방지).
			const loginPath = resolveUnauthRedirect(preLogoutPathname);
			if (loginPath) {
				// window.location 은 host 객체라 history state structured-clone 시 DataCloneError 위험.
				// AdminLogin 은 from.pathname/from.search 만 사용하므로 plain 객체로 전달.
				history.push({
					pathname: loginPath,
					state: { from: { pathname: preLogoutPathname, search: preLogoutSearch } },
				});
			}
		}
	}, []);

	const init = async () => {
		dispatch(RayCodeAction.GetAll());
		setLoading(false);
	}

	const getManagerGroupInfoByCompanyId = async () => {
		const parsed = safeGetJSON('user');
		if (!parsed) return;
		const companyId = parsed?.companyId;
		if (companyId) {
			await GetLicenseByCompanyId(companyId);
		}
    };

	useEffect(() => {
		if (alert.message != "" && !alert.isClose) {
			if (alert.type == "alert-success") {
				setAlertToast({ type: "success", show: true, message: alert.message });
			} else {
				setAlertToast({ type: "error", show: true, message: alert.message });
			}
		}
		// 성공은 3초, 오류는 실패 사유를 읽을 수 있도록 6초 유지 (U-40)
		const hideMs = (alert.message != "" && !alert.isClose && alert.type != "alert-success") ? 6 * 1000 : 3 * 1000;
		const timer = setTimeout(() => setAlertToast(prev => ({ ...prev, show: false })), hideMs);
		return () => clearTimeout(timer);
	}, [alert]);

	return (
		<div id="App">
			<ErrorBoundary>
			<Router history={history}>
				{standAlone && <>
					<Switch>
						<Route exact path="/register" component={ProductRegistByUser} />
					</Switch>
				</>}
				{!loading && !standAlone && !isAdmin && (		//Tech 페이지
					<>
						{isLogin && <SideMenu />}
						<Suspense fallback={<Loading />}>
						<Switch>
							<AuthRoute path="/Home" component={HomePage} />
							<AuthRoute path="/MyInfo/:view?" component={MyInfo} />
							<AuthRoute path="/UserAccount" component={UserAccount} />
							<AuthRoute path="/MyFavorite/:view?" component={MyFavorite} />
							<AuthRoute path="/MySearch/:view?" component={MySearch} />
							<AuthRoute path="/UserSettings" component={UserSettings} />
							<AuthRoute path="/PasswordConfirm" component={PasswordConfirm} />
							<AuthRoute path="/UpdatePassword" component={UpdatePassword} />
							<AuthRoute path="/Sites" component={SiteListView} />
							<AuthRoute path="/MyTask/:view?" component={MyTask} />
							<AuthRoute path="/ReportManager/:view?" component={MyReportManager} />
							<AuthRoute path="/Site/:siteId/:view?" component={SiteView} />
							<AuthRoute path="/Service/:ticketKey?" component={ServiceDetail} />
							<AuthRoute path="/Product/:sn/:view?" component={ProductView} />
							<AuthRoute path="/ServiceAddNew" component={ServiceAddNew} />
							<AuthRoute path="/Calendar" component={MyCalendar} />
							<AuthRoute path="/Guides/:view?" component={MyGuide} />
							<AuthRoute path="/InstallationGuide" component={InstallationGuide} />
							<AuthRoute path="/SettingWizardGuide" component={SettingWizardGuide} />
							<AuthRoute path="/QRScan" component={QRScan} />
							<AuthRoute path="/Notification" component={MyNotification} />
							<AuthRoute path="/UserInfo/:adminid" component={UserInfo} />
							<AuthRoute path="/SiteSurvey/:_id?/:view?" component={SiteSurvey} />
							<AuthRoute path="/Installation/:_id?/:view?" component={Installation} />
							<Route path="/ForgotPassword" component={ForgotPassword} />
							<Route path="/ResetNewPassword" component={ResetNewPassword} />
							<Route path="/ForgotPasswordSent" component={ForgotPasswordSent} />
							<Route path="/IubendaLogin" component={IubendaLogin} />
							<Route exact path="/Login" component={LoginPage} />
							<AuthRoute exact path="/" component={HomePage} />
							<Route path="/Terms" component={TermsRedirect} />
							{/* U-23: 마지막 라우트 — 미정의 경로. 비로그인은 AuthRoute 가 로그인으로 회수 */}
							<AuthRoute component={NotFound} />
						</Switch>
						</Suspense>
						{isLogin && <ErrorCodeLookup />}
						{isLogin && <LoggedBottomMenu />}
						{isLogin && <ProductErrorEdit />}
					</>
				)}
				{!loading && !standAlone && isAdmin && (
					<div className="rayadmin">
						{isLogin && <AdminTopMenu isDashboard={isDashboard} />}
						{isLogin && <AdminLeftMenu />}
						<Suspense fallback={<Loading />}>
						<Switch>
							<AuthRoute exact path="/Admin/License" component={LicenseHub} />
							<AuthRoute path="/Admin/Dashboard" component={AdminDashboard} />
							<AuthRoute path="/Admin/AdminCalendar" component={AdminCalendar} />
							<AuthRoute path="/Admin/AdminUserList" component={AdminUserList} />
							<AuthRoute path="/Admin/AdminUserAdd" component={AdminUserAdd} />
							<AuthRoute path="/Admin/AdminUserInfo/:adminid/:view?" component={AdminUserEdit} />
							<AuthRoute path="/Admin/AdminCompanyList" component={AdminCompanyList} />
							<AuthRoute path="/Admin/AdminCompanyInfo/:companyId/:view?" component={AdminCompanyEdit} />
							<AuthRoute path="/Admin/AdminCompanyAdd" component={AdminCompanyAdd} />
							<AuthRoute path="/Admin/AdminCompanyInfo/:companyId" component={AdminCompanyEdit} />

							<AuthRoute path="/Admin/AdminErrorDashboard" component={AdminErrorDashboard} />
							<AuthRoute path="/Admin/AdminWarrantyDashboard" component={AdminWarrantyDashboard} />
							<AuthRoute path="/Admin/AdminTenYears" component={AdminTenYears} />

							<AuthRoute path="/Admin/AdminProductImport" component={AdminProductImport} />
							<AuthRoute path="/Admin/AdminProductImportSmall" component={AdminProductImportSmall} />
              <AuthRoute path="/Admin/AdminProductImportShipment" component={AdminProductImportShipment} />
							<AuthRoute path="/Admin/AdminProductDashboard" component={AdminProductDashboard} />
							<AuthRoute path="/Admin/AdminProductList" component={AdminProductList} />
							<AuthRoute path="/Admin/AdminProductList/:companyId" component={AdminProductList} />
							<AuthRoute path="/Admin/AdminProductStockList" component={AdminProductStockList} />
							<AuthRoute path="/Admin/AdminProductAdd" component={AdminProductAdd} />
							<AuthRoute path="/Admin/AdminProductInfo/:sn/:view?" component={AdminProductInfo} />
							<AuthRoute path="/Admin/AdminProductCompanyImport/:companyId" component={AdminProductCompanyImport} />

							<AuthRoute path="/Admin/AdminErrorInfo/:eCode/:sn/:errId/:view?" component={AdminErrorInfo} />
							<AuthRoute path="/Admin/AdminErrorList" component={AdminErrorList} />

							<AuthRoute path="/Admin/AdminSiteList" component={AdminSiteList} />
							<AuthRoute path="/Admin/AdminSiteDashboard" component={AdminSiteDashboard} />
							<AuthRoute path="/Admin/AdminErrorCodeList" component={AdminErrorCodeList} />
							<AuthRoute path="/Admin/AdminErrorCodeAdd" component={AdminErrorCodeAdd} />
							<AuthRoute path="/Admin/AdminErrorCodeInfo/:errorCode/:lang?/:view?" component={AdminErrorCodeInfo} />
							<AuthRoute path="/Admin/AdminErrorCodeInfoById/:_id" component={AdminErrorCodeInfo} />
							<AuthRoute path="/Admin/AdminSiteInfo/:id/:view?" component={AdminSiteEdit} />
							<AuthRoute path="/Admin/AdminSiteAdd" component={AdminSiteAdd} />

							<AuthRoute path="/Admin/AdminSiteSurveyList" component={AdminSiteSurveyList} />
							<AuthRoute path="/Admin/AdminSiteSurveyInfo/:id" component={AdminSiteSurveyInfo} />

							<AuthRoute path="/Admin/AdminInstallationList" component={AdminInstallationList} />
							<AuthRoute path="/Admin/AdminInstallationInfo/:id" component={AdminInstallationInfo} />

							<AuthRoute path="/Admin/AdminRayDataList" component={AdminRayDataList} />
							<AuthRoute path="/Admin/AdminNotification" component={MyNotification} />
							<AuthRoute path="/Admin/MyInfo/:view?" component={MyInfo} />
							<AuthRoute path="/Admin/MyInfo" component={MyInfo} />
							<AuthRoute path="/Admin/UpdatePassword" component={UpdatePassword} />

							<AuthRoute path="/Admin/AdminCustomFieldList" component={AdminCustomFieldList} />

							<AuthRoute path="/Admin/AdminServiceStatus" component={AdminServiceStatus} />
						<AuthRoute path="/Admin/AdminNotificationEmailSetting" component={AdminNotificationEmailSetting} />
							<AuthRoute path="/Admin/AdminServiceDashboard" component={AdminServiceDashboard} />
							<AuthRoute path="/Admin/AdminServiceList" component={AdminServiceList} />
							<AuthRoute path="/Admin/AdminServiceAdd" component={AdminServiceAdd} />
							<AuthRoute path="/Admin/AdminService/:ticketKey" component={AdminServiceInfo} />
							<AuthRoute path="/Admin/AdminServiceExportCSR" component={AdminServiceExportCSR} />

							<AuthRoute path="/Admin/AdminRayCode" component={AdminRayCode} />
							<AuthRoute path="/Admin/AdminRayCodeInfo" component={AdminRayCodeInfo} />

							<AuthRoute path="/Admin/AdminProductPart" component={AdminProductPart} />
							<AuthRoute path="/Admin/AdminProductPartInfo" component={AdminProductPartInfo} />

							<AuthRoute path="/Admin/AdminConditionSearch" component={AdminStatistics} />
							<Route path="/Admin/AdminSetting" render={() => <Redirect to={`${ROUTES.ADMIN_MY_INFO}/setting`} />} />

							<AuthRoute path="/Admin/AdminTranslate" component={AdminTranslate} />

							<AuthRoute path="/Admin/AdminSparePartsStock" component={AdminSparePartsStock} />

							<AuthRoute path="/Admin/AdminSpareParts" component={AdminSpareParts} />
							<AuthRoute path="/Admin/AdminSparePartsDetail/:_id" component={AdminSparePartsDetail} />
							<AuthRoute path="/Admin/AdminSparePartsOrder" component={AdminSparePartsOrder} />
							<AuthRoute path="/Admin/AdminSparePartsOrderFree" component={AdminSparePartsOrderFree} />

							<AuthRoute path="/Admin/AdminSparePartsOrderList/" component={AdminSparePartsOrderList} />

							<AuthRoute path="/Admin/AdminSparePartsOrderListManager" component={AdminSparePartsOrderListManager} />
							<AuthRoute path="/Admin/AdminSparePartsOrder/:_id" component={AdminSparePartsOrderDetail} />
							<AuthRoute path="/Admin/AdminSparePartsInRegist/:_id" component={AdminSparePartsInRegist} />
							<AuthRoute path="/Admin/AdminSparePartsOutRegist/:_id" component={AdminSparePartsOutRegist} />
							<AuthRoute path="/Admin/AdminSparePartsDealerOutRegist" component={AdminSparePartsDealerOutRegist} />

							<AuthRoute path="/Admin/AdminSparePartsOutList" component={AdminSparePartsOutList} />
							<AuthRoute path="/Admin/AdminSparePartsOutDetail/:_id" component={AdminSparePartsOutDetail} />

							<AuthRoute path="/Admin/AdminSparePartsCompany" component={AdminSparePartsCompany} />
							<AuthRoute path="/Admin/AdminSparePartsCompanyDetail/:_id" component={AdminSparePartsCompanyDetail} />

							{/* FEAT-035 PMCF 수집장비 관리 — URL 직접 진입(/pmcf), HQ Super user only, 메뉴 미노출 */}
							<AuthRoute path="/pmcf" component={AdminPMCFRegistry} />

							<AuthRoute path="/Admin/AdminSparePartsCIPublish" component={AdminSparePartsCIPublish} />

							<AuthRoute path="/Admin/AdminEmpty" component={EmtryCom} />

							<Route exact path="/Admin/Login" component={AdminLogin} />
							<Route path="/Terms" component={TermsRedirect} />
							{/* U-23: 마지막 라우트 — 미정의 경로 */}
							<AuthRoute component={NotFound} />
						</Switch>
						</Suspense>
						{isLogin && <ServiceModalPopup />}
						{isLogin && <LoggedAdminFooter />}
						<ToastContainer />
					</div>
				)}
				<Toast option={alertToast} />
			</Router>
			</ErrorBoundary>
		</div>
	);
};

const mapState = (state) => {
	return {
		alert: state.AlertReducer,
		isLogin: state.AuthReducer.loggingIn,
		userToken: state.AuthReducer.userToken,
		user: state.AuthReducer.user,
		companies: state.CompanyReducer.companies
	};
};

const mapDispatch = (dispatch) => ({
	AlertClose: () => dispatch(AlertAction.Closed()),
	//GetAllCompany: () => dispatch(CompanyAction.GetCompany()),
	GetAllCustomField: () => dispatch(CustomFieldAction.GetAll()),
	GetLicenseByCompanyId: (companyId) => dispatch(LicenseAction.GetLicenseByCompanyId(companyId))
});

export default connect(mapState, mapDispatch)(App);
